import React, { useState, useContext } from 'react';

import { ValidationError } from 'craft/types';

type ChangeStatus = 'saved' | 'pending';

interface ValidationErrorContext {
  changeStatus: ChangeStatus;
  errors: ValidationError[];
  // is there a nicer way mark errors as fixed without having to count them over?
  fixedErrors: ValidationError[];
  // an api error is a fatal message. this is basically any failure in the api
  apiErrorMessage?: string | boolean;

  selectedErrorNodeId: string | null;
  setSelectedErrorNodeId: (nodeId: string | null) => void;
  setChangeStatus: (status: ChangeStatus) => void;
}

interface Props {
  children: any;
  errors?: ValidationError[];
  apiErrorMessage?: string;
}

export const ErrorContext = React.createContext<ValidationErrorContext>({
  errors: [],
  fixedErrors: [],
  changeStatus: 'saved',
  selectedErrorNodeId: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSelectedErrorNodeId: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setChangeStatus: () => {},
});

export const useErrorContext = () => useContext(ErrorContext);

const ValidationErrorManager = ({ children, apiErrorMessage, errors = [] }: Props) => {
  const [changeStatus, setChangeStatus] = useState<ChangeStatus>('saved');
  const [selectedErrorNodeId, setSelectedErrorNodeId] = useState<string | null>(null);
  const initialContextValue = {
    errors,
    fixedErrors: [],
    apiErrorMessage,
    selectedErrorNodeId,
    setSelectedErrorNodeId,
    changeStatus,
    setChangeStatus,
  };

  return <ErrorContext.Provider value={initialContextValue}>{children}</ErrorContext.Provider>;
};

export default ValidationErrorManager;
